import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'templateType',
      type: 'select',
      label: '类型',
      placeholder: '请选择类型',
      clearable: true,
      options: [
        { title: '文案', value: '1' },
        { title: '图片', value: '2' }
      ]
    },
    {
      field: 'templateTitle',
      type: 'input',
      label: '模版标题',
      placeholder: '请输入标题'
    },
    {
      field: 'question',
      type: 'input',
      label: '问题',
      placeholder: '请输入问题'
    },
    {
      field: 'trackingThought',
      type: 'input',
      label: '跟踪思路',
      placeholder: '请输入跟踪思路'
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '筛选日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          const sixMonthsAgo = new Date();
          sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
          return date.getTime() < sixMonthsAgo.getTime();
        }
      }
    }
  ]
}
